import { ClerkLocalization } from '@/clients/util/clerk-localization';
import { isLanguageCode, LanguageCode } from '@/ifaces/language';
import type { LocalizationResource } from '@clerk/types';
import {
  createContext,
  createElement,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from 'react';

export type LocalizationContextType = {
  code: LanguageCode;
  clerk: LocalizationResource;
  setCode: Dispatch<SetStateAction<LanguageCode>>;
};

const LocalizationContext = createContext<LocalizationContextType>({
  code: LanguageCode.English,
  clerk: ClerkLocalization[LanguageCode.English],
  setCode: (_1: LanguageCode | ((_2: LanguageCode) => LanguageCode)) => {},
});

export function useLocalizationContext() {
  return useContext(LocalizationContext);
}

export const LocalizationContextProvider = (props: PropsWithChildren) => {
  const [code, setCode] = useState(LanguageCode.English);
  const clerk = ClerkLocalization[isLanguageCode(code) ? code : LanguageCode.English];
  const value = { clerk, code, setCode };
  return createElement(LocalizationContext.Provider, { value }, props.children);
};
